module.exports = __webpack_public_path__ + "img/individual-meter-water-meter-cold-lg.0f2f1acf.svg";